var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tk",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tk-outer"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "tk-rect",
    x: 1,
    y: 0.5,
    width: 39,
    height: 39,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "tk-inner"
  }, /*#__PURE__*/React.createElement("path", {
    id: "tk-path",
    d: "M25.3165 9H21.6088V23.9855C21.6088 25.771 20.1828 27.2377 18.4082 27.2377C16.6336 27.2377 15.2076 25.771 15.2076 23.9855C15.2076 22.2319 16.602 20.7971 18.3132 20.7333V16.971C14.5422 17.0348 11.5 20.1275 11.5 23.9855C11.5 27.8754 14.6055 31 18.4399 31C22.2743 31 25.3798 27.8435 25.3798 23.9855V16.3014C26.7742 17.3217 28.4854 17.9275 30.2917 17.9594V14.1971C27.503 14.1015 25.3165 11.8058 25.3165 9Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTk);
export default __webpack_public_path__ + "static/media/tk.089648dbc7605a6fa8b67c0ebbd5cd59.svg";
export { ForwardRef as ReactComponent };